/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { Legend } from './label';
var fieldSetStyles = css({
  marginBlockStart: "var(--ds-space-100, 8px)"
});

/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */
var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
    legend = _ref.legend;
  return jsx("fieldset", {
    css: fieldSetStyles
  }, legend && jsx(Legend, null, legend), children);
};
export default Fieldset;